import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BlockUiService } from '../../services/block-ui.service';

@Component({
  selector: 'app-block-ui',
  templateUrl: './block-ui.component.html',
  styleUrl: './block-ui.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class BlockUiComponent {
  protected readonly blockUi = inject(BlockUiService);
}
